import BaseAPI from '../base'

function getList() {
    return BaseAPI.get(`/employees/list`);
}

function addEmployee(data) {
    return BaseAPI.post(`/employees/add`, data);
}

function removeEmployee(id) {
    return BaseAPI.post(`/employees/remove/${id}`);
}

function updateEmployee(id, data) {
    return BaseAPI.post(`/employees/update/${id}`, data);
}

function activateEmployee(id, password) {
    return BaseAPI.post(`/employees/activate/${id}`, {
        password
    });
}

function canActivateEmployee(id) {
    return BaseAPI.get(`/employees/can_activate/${id}`);
}

export default {
    getList,
    addEmployee,
    removeEmployee,
    updateEmployee,
    activateEmployee,
    canActivateEmployee
}